import { useState } from 'react';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface LatestUpdateProps {
  movies: Movie[];
}

export default function LatestUpdate({ movies }: LatestUpdateProps) {
  const [activeTab, setActiveTab] = useState<string>('all');

  const tabs = [
    { key: 'all', label: '全部' },
    { key: 'movie', label: '电影' },
    { key: 'tv', label: '电视剧' },
    { key: 'variety', label: '综艺' },
    { key: 'anime', label: '动漫' },
  ];

  const filtered = activeTab === 'all'
    ? movies
    : movies.filter((m) => m.category === activeTab);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-900">
            最新更新
          </h2>
          <div className="flex items-center gap-1 bg-background-100 rounded-full p-1 w-fit">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-1.5 text-sm rounded-full whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  activeTab === tab.key
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
        <div className="space-y-1">
          {filtered.map((movie) => (
            <MovieCard key={movie.id} movie={movie} variant="landscape" />
          ))}
        </div>
      </div>
    </section>
  );
}